import React, { useContext, useEffect } from 'react';
import { AlumnosContext } from '../../../context/alumnos/AlumnosContext';
import Tabla from './../../Tabla/Tabla';

export default function Pagos() {
	const alumnoCtx = useContext(AlumnosContext);
	const { getAlumnos, alumnos } = alumnoCtx;

	const columns = [
		{ text: 'Nombre' },
		{ text: 'Categoria' },
		// { text: 'Estado' },
		{ text: '' },
	];

	useEffect(() => {
		// handleResetPagos();
		getAlumnos();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return <Tabla data={alumnos} columns={columns} pagos options />;
}
